import Axios from "axios";
import { sanitize } from "../helpers/Class";
import Config from "../../config";

const DiceAPI = {
    // eslint-disable-next-line no-unused-vars,max-lines-per-function
    install(Vue) {
        const axios = Axios.create({
            baseURL: Config.diceAPI.baseURL,
            timeout: 0,
            headers: {
                "Content-Type": "application/json",
            },
            auth: {
                username: Config.diceAPI.basicAuth.username,
                password: Config.diceAPI.basicAuth.password,
            },
        });

        Vue.prototype.$diceAPI = {};

        Vue.prototype.$diceAPI.getBaseUrl = () => Config.diceAPI.baseURL;
        Vue.prototype.$diceAPI.getConfig = () => axios.get("/");

        Vue.prototype.$diceAPI.getCountries = () => axios.get(`/countries`);

        Vue.prototype.$diceAPI.getCurrencies = () => axios.get(`/currencies`);

        Vue.prototype.$diceAPI.getCarriers = () => axios.get(`/carriers?enabled=true&show-privates=true`);

        Vue.prototype.$diceAPI.getCarrier = id => axios.get(`/carriers/${id}`);

        Vue.prototype.$diceAPI.postCarrier = carrier => axios.post(`/carriers`, sanitize(carrier));

        Vue.prototype.$diceAPI.patchCarrier = carrier => axios.patch(`/carriers/${carrier.id}`, sanitize(carrier));

        Vue.prototype.$diceAPI.getCarrierDestination = id => axios.get(`/carrier-destinations/${id}`);

        Vue.prototype.$diceAPI.postCarrierDestination = carrierDestination => axios.post(`/carrier-destinations`, sanitize(carrierDestination));

        Vue.prototype.$diceAPI.patchCarrierDestination = carrierDestination => axios.patch(`/carrier-destinations/${carrierDestination.id}`, sanitize(carrierDestination));

        Vue.prototype.$diceAPI.deleteCarrierDestination = carrierDestination => axios.delete(`/carrier-destinations/${carrierDestination.id}`);

        Vue.prototype.$diceAPI.postCarrierDestinationPrice = carrierDestinationPrice => axios.post(`/carrier-destination-prices`, sanitize(carrierDestinationPrice));

        Vue.prototype.$diceAPI.patchCarrierDestinationPrice = carrierDestinationPrice => axios.patch(`/carrier-destination-prices/${carrierDestinationPrice.id}`, sanitize(carrierDestinationPrice));

        Vue.prototype.$diceAPI.deleteCarrierDestinationPrice = carrierDestinationPrice => axios.delete(`/carrier-destination-prices/${carrierDestinationPrice.id}`);

        Vue.prototype.$diceAPI.postCarrierTax = carrierTax => axios.post(`/carrier-taxes`, sanitize(carrierTax));

        Vue.prototype.$diceAPI.patchCarrierTax = carrierTax => axios.patch(`/carrier-taxes/${carrierTax.id}`, sanitize(carrierTax));

        Vue.prototype.$diceAPI.deleteCarrierTax = carrierTax => axios.delete(`/carrier-taxes/${carrierTax.id}`);

        Vue.prototype.$diceAPI.getCarrierArea = id => axios.get(`/carrier-areas/${id}`);

        Vue.prototype.$diceAPI.postCarrierArea = carrierArea => axios.post(`/carrier-areas`, sanitize(carrierArea));

        Vue.prototype.$diceAPI.patchCarrierArea = carrierArea => axios.patch(`/carrier-areas/${carrierArea.id}`, sanitize(carrierArea));

        Vue.prototype.$diceAPI.deleteCarrierArea = carrierArea => axios.delete(`/carrier-areas/${carrierArea.id}`);

        Vue.prototype.$diceAPI.addCarrierAreaDestination = (carrierAreaId, carrierDestinationId) => axios.post(`/carrier-areas/${carrierAreaId}/destinations`, { carrierDestinationId });

        Vue.prototype.$diceAPI.deleteCarrierAreaDestination = (carrierAreaId, carrierDestinationId) => axios.delete(`/carrier-areas/${carrierAreaId}/destinations/${carrierDestinationId}`);

        Vue.prototype.$diceAPI.postCarrierAreaPrice = (carrierAreaId, carrierAreaPrice) => axios.post(`/carrier-areas/${carrierAreaId}/prices`, sanitize(carrierAreaPrice));

        Vue.prototype.$diceAPI.patchCarrierAreaPrice = (carrierAreaId, carrierAreaPrice) => axios.patch(`/carrier-areas/${carrierAreaId}/prices/${carrierAreaPrice.id}`, sanitize(carrierAreaPrice));

        Vue.prototype.$diceAPI.deleteCarrierAreaPrice = (carrierAreaId, carrierAreaPrice) => axios.delete(`/carrier-areas/${carrierAreaId}/prices/${carrierAreaPrice.id}`);
    },
};

export default DiceAPI;